// Store/Reducers/dataStore.js

// Action Types
export const SAVE_CODE = 'SAVE_CODE'
export const SAVE_DATA = 'SAVE_DATA'
export const SAVE_PROFIL_DATA = 'SAVE_PROFIL_DATA'
//export const DELETE_NOTE = 'DELETE_NOTE'

// Action Creators
export function savecode(code) {
  return {
    type: SAVE_CODE,
    code
  }
}

export function savedata(data) {
  return {
    type: SAVE_DATA,
    data
  }
}

export function saveprofildata(profilData) {
  return {
    type: SAVE_PROFIL_DATA,
    profilData
  }
}

// reducer
const initialState = []

function dataReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_CODE:
      return {
        code: action.code
      };
    case SAVE_DATA:
      return {
        data: action.data
      };
    case SAVE_PROFIL_DATA:
      return {
        profilData: action.profilData
      };

    default:
      return state
  }
}

export default dataReducer
